import { observer } from 'mobx-react-lite'
import { type ConfirmPayoutDialogViewModel } from '@/features/payouts/admin/review/ConfirmPayoutDialogViewModel'
import { ConfirmPayoutModal } from '@/features/payouts/admin/review/components/ConfirmPayoutModal'

export interface ConfirmPayoutModalContainerProps {
  vm: ConfirmPayoutDialogViewModel
}

export const ConfirmPayoutModalContainer = observer(
  function ConfirmPayoutModalContainer({
    vm,
  }: ConfirmPayoutModalContainerProps) {
    return (
      <ConfirmPayoutModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onConfirm={vm.confirm}
        total={vm.total}
        transactionCount={vm.transactionCount}
      />
    )
  },
)
